// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"92e336bf","803":"3c1c4280","891":"7612ef4e"}[chunkId] + ".chunk.js";
};